module.exports = __webpack_public_path__ + "img/logo-feelgood-colored-linebreak.b60c712a.svg";